/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PDFViewer from 'components/PDFViewer';

type EditInvitationModalProps = {
  onClose: () => void,
  url: string,
  onLoadError?: () => void,
};

function PdfViewerModal( {
  onClose, url, onLoadError,
}: EditInvitationModalProps ) {
  const { t } = useTranslation();

  return (
    <Modal
      className="modal-carousel"
      show
      centered
      fullscreen
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton>
        <h3>Visor de fichero</h3>
      </Modal.Header>
      <Modal.Body className="p-1" style={{ height: '80vh', paddingBottom: 0 }}>
        <PDFViewer
          src={url}
          width="100%"
          height="100%"
          onError={onLoadError}
        />
      </Modal.Body>
    </Modal>
  );
}

export default PdfViewerModal;
